export class CreateLinkRegistryError extends Error {
}